export default "__VITE_ASSET__H2BeA0g7__"